import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager } from 'ng-jhipster';
import { Location } from './location.model';
import { LocationService } from './location.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'jhi-location-detail',
    templateUrl: './location-detail.component.html'
})
export class LocationDetailComponent implements OnInit, OnDestroy {

    location: Location;
    private subscription: any;
    private locationSubscription: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private locationService: LocationService,
        private eventManager: EventManager,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['location']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
        this.locationSubscription = this.eventManager
        .subscribe('locationListModification',
        (response) => {
            this.location = response['content']['content'];
        });
    }

    load(id) {
        this.locationService.find(id).subscribe(location => {
            this.location = location;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/location/location-detail.component.ts